import { render, staticRenderFns } from "./ManageBooking.vue?vue&type=template&id=b7c243b4"
import script from "./ManageBooking.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageBooking.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports